import { render, staticRenderFns } from "./ClientsNotebookFilters.vue?vue&type=template&id=cbac5506"
import script from "./ClientsNotebookFilters.vue?vue&type=script&lang=js"
export * from "./ClientsNotebookFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports